import { ActiveMessagePermission } from 'models/Blip/Index';
import { BaseRequest } from './BaseRequest';

export class SchedulerRequest extends BaseRequest {
    ActiveMessagePermission : ActiveMessagePermission
    
    constructor(activeMessagePermission: ActiveMessagePermission, clusterName: string, botIdentifier: string) {
      super();
      this.ActiveMessagePermission = activeMessagePermission;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
    }
}